import { transformConstants } from '../helpers/transformConstants';

const componentEventConstants = transformConstants([
  // INGREDIENT CATEGORY
  'MOKAPOS_INGREDIENT_CATEGORY_CHANGE_OUTLET',
  'MOKAPOS_INGREDIENT_CATEGORY_SELECT',
  'MOKAPOS_INGREDIENT_CATEGORY_CREATE_ALL_OUTLET',
  'MOKAPOS_INGREDIENT_CATEGORY_CREATE_ONE_OUTLET',
  'MOKAPOS_INGREDIENT_CATEGORY_DELETE',
  'MOKAPOS_INGREDIENT_CATEGORY_ASSIGN',

  // INVENTORY TRANSFER
  'MOKAPOS_INVENTORY_TRANSFER_EXPORT',

  // INGREDIENT LIBRARY
  'MOKAPOS_INGREDIENT_LIBRARY_EXPORT',
  'MOKAPOS_INGREDIENT_LIBRARY_START_TRIAL',
  'MOKAPOS_INGREDIENT_LIBRARY_IMPORT_INGREDIENT',
  'MOKAPOS_INGREDIENT_LIBRARY_CREATE_SFI_LIBRARY',

  // PAYMENT CONFIGURATION
  'MOKAPOS_PAYMENT_CONFIGURATION_ADD',

  // REGISTRATION
  'MOKAPOS_REGISTRATION_CREATE_EMAIL',
  'MOKAPOS_REGISTRATION_BUSINESS_INFORMATION_COMPLETED',

  // REPORTS
  'MOKAPOS_REPORT_DISCOUNT_EXPORT',
  'MOKAPOS_REPORT_COLLECTED_EXPORT',
  'MOKAPOS_REPORT_CATEGORY_SALES_EXPORT',

  // BILLING
  'MOKAPOS_RECURRING_DEBIT',
  'MOKAPOS_MODIFY_DEBIT_INFO',

  // AUTH
  'MOKAPOS_LOGIN',
  'MOKAPOS_LOGOUT',

  // ITEM LIBRARY
  'MOKAPOS_LIBRARY_ITEM_IMPORT_MODIFY',
  'MOKAPOS_LIBRARY_ITEM_IMPORT_REPLACE',
  'MOKAPOS_LIBRARY_ITEM_CREATE_SALES_TYPE_PRICING_ALL_OUTLET',
  'MOKAPOS_LIBRARY_ITEM_CREATE_SALES_TYPE_PRICING_ONE_OUTLET',
  'MOKAPOS_LIBRARY_ITEM_CREATE_BASIC_PRICING_ALL_OUTLET',
  'MOKAPOS_LIBRARY_ITEM_CREATE_BASIC_PRICING_ONE_OUTLET',
  'MOKAPOS_LIBRARY_ITEM_UPDATE_SALES_TYPE_PRICING',
  'MOKAPOS_LIBRARY_ITEM_UPDATE_BASIC_PRICING',
  'MOKAPOS_LIBRARY_ITEM_START_TRACKING_STOCK_ALERT',

  // OTHER LIBRARY
  'MOKAPOS_LIBRARY_CATEGORY_CREATE_ONE_OUTLET',
  'MOKAPOS_LIBRARY_CATEGORY_CREATE_ALL_OUTLET',
  'MOKAPOS_LIBRARY_PROMO_CREATE',
  'MOKAPOS_LIBRARY_DISCOUNT_CREATE',
  'MOKAPOS_LIBRARY_TAX_CREATE_ONE_OUTLET',
  'MOKAPOS_LIBRARY_TAX_CREATE_ALL_OUTLET',
  'MOKAPOS_LIBRARY_GRATUITY_CREATE_ONE_OUTLET',
  'MOKAPOS_LIBRARY_GRATUITY_CREATE_ALL_OUTLET',
  'MOKAPOS_LIBRARY_CREATE_SALES_TYPE_ONE_OUTLET_SUCCESS',
]);

export { componentEventConstants };
